export default __webpack_public_path__ + "b0d0da974365f961fedf768dbed93616.gif";